import { EditUser } from './presentation/components/EditUser/EditUser';
import { Logout } from './presentation/components/Authentication/Logout/Logout';

interface RouteType {
  label: string;
  path: string;
  component?: React.FC;
  isDropdown?: boolean;
  exact?: boolean;
  children?: Pick<RouteType, 'label' | 'path' | 'component'>[];
}

export const routes: RouteType[] = [
  {
    path: '/',
    label: 'Edit User',
    component: EditUser,
    exact: true
  },
  {
    path: '/logout',
    label: 'Logout',
    component: Logout,
    exact: true
  }
];
